export default {
    header:{
        addWidget: {
            title: "Widget hinzufügen",
            button: {
                title: "Fügen Sie ein Widget hinzu",
                hide: "Hinzugefügte Widgets ausblenden"
            }
        },
        datePicker:{
            title: "Datumsbereich",
            options: {
                range: "Bereich",
                today: "Heute",
                yesterday: "Gestern",
                last7Days: "Letzte 7 Tage",
                thisWeek: "Diese Woche",
                last30Days: "Letzte 30 Tage",
                thisMonth: "Diesen Monat",
                lastYear: "Letztes Jahr",
                thisYear: "Dieses Jahr",
            },
            compareTo: {
                title: "Vergleichen mit",
                previousPeriod: "Vorheriger Zeitraum",
                previousYear: "Voriges Jahr"
            },
            cancel: "Bewerbung",
            apply: "Anwenden",
            wrongStartDate: "Das Startdatum kann nicht vor %{date} beginnen."

        },
        warning: {
            tooltip: "Klicken Sie für weitere Informationen"
        },
        connection: {
            up: "Verbindung AKTIV",
            down: "Verbindung UNTERBROCHEN"
        }
    },
    widget:{
        options:{
            move: "Umzug",
            delete: "Löschen"
        },
        moreInfo: "Mehr Informationen",
        noData: "Für dieses Widget sind keine Daten verfügbar.",
        noDataForPill: "keine Daten für %{pill} verfügbar.",
        sync:{
            object: "Objekte",
            problem: "Problem",
            nothing: "Keine Synchronisationsprobleme, tolle Arbeit!"
        },
        search:{
            terms:{
                title: "Suchbegriff",
                value: "# Sucht"
            }
        },
        topProducts: {
            tableTitle: "Produkt"
        },
        topClients: {
            tableTitle: "Klient"
        },
        filters: {
            logins: "Anmeldungen",
            sales: "Verkauf",
            orders: "Bestellungen",
            views: "Ansichten"
        },
        pageviews: {
            name: "Seitenaufrufe",
            info: "Zeigt die meistbesuchten Seiten mit Filtern für URL, Konto und Anzahl der Seitenaufrufe"
        },
        pageVisits: {
            name: "Letzte Besuche",
            info: "Zeigt die neuesten Seitenbesuche mit Filtern für URL und Konto"
        }
    },
    footer:{
        cancel: "Abbrechen",
        save: "Änderungen speichern"
    }
}